import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { useTimeLeft } from '@sorare/core/src/hooks/useTimeLeft';
import { glossary } from '@sorare/core/src/lib/glossary';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const CountdownContainer = styled.div`
  --countdown-transition: all 0.3s 0.2s;
  display: flex;
  gap: var(--unit);
  color: var(--c-static-neutral-100);
  align-items: baseline;
  &.expanded {
    gap: var(--double-unit);
  }
`;

const Segment = styled(Vertical).attrs({ gap: 0.5, center: true })`
  font-variant-numeric: tabular-nums;
  font-size: 18px;
  line-height: 1;
  letter-spacing: -1px;

  .expanded & {
    transition: var(--countdown-transition);
    font-size: 18px;
    @media ${laptopAndAbove} {
      font-size: 48px;
    }
  }
`;

const Unit = styled(LabelS)`
  transition: var(--countdown-transition);
  @media ${laptopAndAbove} {
    .expanded & {
      font: var(--t-16);
    }
  }
`;

type Props = { endDate: Date; expanded: boolean };

export const Countdown = ({ endDate, expanded }: Props) => {
  const { elements } = useTimeLeft(endDate);

  return (
    <CountdownContainer className={classNames({ expanded })}>
      <FormattedMessage
        {...glossary.starUniqueCountdown}
        values={{
          ...elements,
          segment: (...chunks) => <Segment>{chunks}</Segment>,
          unit: (...chunks) => (
            <Unit color="var(--c-neutral-600)">{chunks}</Unit>
          ),
        }}
      />
    </CountdownContainer>
  );
};
